import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button/Button';
import Heading from '../Heading/Heading';
import './SectionedLinks.scss';

interface ILink {
  title: React.ReactNode | React.ReactNode[];
  href: string;
  onClick?: () => void;
}

interface Group {
  title?: string;
  links: ILink[];
}

interface Section {
  title: React.ReactNode | React.ReactNode[];
  groups: Group[];
}

export interface SectionsLinksProps {
  sections: Section[];
}

const SectionedLinks: React.FC<SectionsLinksProps> = ({ sections }: SectionsLinksProps) => {
  return (
    <section className="mss-sectioned-links">
      <div className="zb-container zb-container-fluid">
        {sections.map(({ title, groups }, sectionIndex) => (
          <div key={sectionIndex} className="mss-sectioned-links__section">
            <Heading
              level={4}
              as="h4"
              className="mss-sectioned-links__title"
              id={`section-${sectionIndex}-title`}
            >
              {title}
            </Heading>
            {groups.map((group, groupIndex) => (
              <div key={groupIndex} className="mss-sectioned-links__group">
                {group.title && (
                  <Heading
                    level={4}
                    as="h4"
                    id={`section-${sectionIndex}-group-${groupIndex}-title`}
                  >
                    {group.title}
                  </Heading>
                )}
                <ul
                  aria-labelledby={
                    group.title
                      ? `section-${sectionIndex}-group-${groupIndex}-title`
                      : `section-${sectionIndex}-title`
                  }
                >
                  {group.links.map((link, index) => (
                    <li key={index}>
                      {link.href ? (
                        <Link to={link.href} onClick={link.onClick}>
                          {link.title}
                        </Link>
                      ) : (
                        <Button variant="link" onClick={link.onClick}>
                          {link.title}
                        </Button>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};

export default SectionedLinks;
